<template>
  <div :class="`yxtbiz-signup-controls relative ${control.rowClass}`">
    <template v-if="control.name === 'yxt-input-number'">
      <yxt-input-number :class="control.class" v-model="data[control.key]" :step="1" :min="control.min" :max="control.max"></yxt-input-number>
    </template>
    <template v-else-if="control.name === 'yxt-date-picker'">
      <yxt-date-picker :class="control.class" v-model="data[control.key]" :placeholder="language()[control.placeholder]" :type="control.type" :format="control.format" :value-format="control.format" clearable></yxt-date-picker>
    </template>
    <template v-else-if="control.name === 'settings-checked'">
      <settings-checked :class="control.class" :list="data[control.key]" :placeholder="language()[control.placeholder]" :error="false" @click="showDrawer(control.key, control.drawer)" @delete="deleteChecked(control.key, $event)" />
    </template>
    <template v-else-if="control.name === 'yxt-checkbox'">
      <yxt-checkbox v-model="data[control.key]" :true-label="control.trueLabel" :false-label="control.falseLabel">{{language()[control.checkboxLabel]}}</yxt-checkbox>
    </template>
    <template v-else-if="control.name === 'yxt-checkbox-group'">
      <yxt-checkbox-group :class="control.class" v-model="data[control.key]" :direction="control.direction" @change="value => checkboxGroupChange(value, control.options.map(_ => _.key))">
        <yxt-checkbox v-for="(ctl, index) in control.options" :key="index" :label="ctl.key || ctl.value">{{language()[ctl.checkboxLabel]}}</yxt-checkbox>
      </yxt-checkbox-group>
    </template>
    <template v-else-if="control.name === 'yxt-radio-group'">
      <yxt-radio-group v-model="data[control.key]" :direction="control.direction">
        <yxt-radio v-for="(ctl, index) in control.options" :key="index+control.key" :label="ctl.value" :disabled="disabled">{{language()[ctl.label]}}</yxt-radio>
      </yxt-radio-group>
    </template>
    <template v-else-if="control.name === 'yxt-button'">
      <yxt-button :type="control.type" @click="showDrawer(control.key, control.drawer)">{{language()[control.buttonLabel]}}</yxt-button>
    </template>
    <template v-else-if="control.name === 'yxtbiz-teacher-level'">
      <yxtbiz-teacher-level :class="control.class" :setwidth="control.setwidth" :multipleLimit="control.multipleLimit" :defaultValue="data[control.key]" @change="value => levelChange(value, control.key)"></yxtbiz-teacher-level>
    </template>
    <span class="ml12 c-cCBF" v-if="control.info">{{control.infoNum ? language()[control.info].replace('$num', control.infoNum) : language()[control.info]}}</span>
    <span :class="control.msgClass" v-if="control.msgKey">{{data[control.msgKey] || language()[control.msgKey]}}</span>
    <template v-if="control.msgCtl">
      <template v-if="control.msgCtl.name === 'yxt-select'">
        <yxt-select :class="control.msgCtl.class" v-model="data[control.msgCtl.key]">
          <yxt-option v-for="(option, index) in control.msgCtl.options" :key="index" :value="option.value" :label="language()[option.label]"></yxt-option>
        </yxt-select>
      </template>
    </template>
  </div>
</template>

<script>
import settingsChecked from '../../components/config/checked.vue';
export default {
  name: 'YxtbizSignupControls',
  inject: ['language'],
  components: {
    settingsChecked
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    control: {
      type: Object,
      default() {
        return {};
      }
    },
    cfgs: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 行为
    ...{
      showDrawer(key, drawer) {
        this.$set(this.cfgs, 'drawer', {
          ...(this.cfgs.drawer || {}),
          ...drawer,
          dataKey: key,
          value: drawer.type === 'array' ? [...(this.data[key] || [])] : this.data[key],
          show: true
        });
      },
      deleteChecked(key, { index }) {
        this.data[key] = this.data[key].filter((_, i) => i !== index);
        this.$emit('validateField', key);
      },
      checkboxGroupChange(value, keys) {
        for (let i = 0; i < keys.length; i++) {
          if (keys[i]) {
            this.data[keys[i]] = value.includes(keys[i]) ? 1 : 0;
          }
        }
      },
      levelChange(value, key) {
        this.data[key] = value;
        this.$parent.$refs.form.validateField(key);
      }
    }
  }
};
</script>